import { render, staticRenderFns } from "./SlideyMcMenu.vue?vue&type=template&id=631684c0&scoped=true&"
import script from "./SlideyMcMenu.vue?vue&type=script&lang=ts&"
export * from "./SlideyMcMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SlideyMcMenu.vue?vue&type=style&index=0&id=631684c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631684c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
